import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { api } from './api';
import { APPOINTMENTS, DROPDOWNS, PARENTS, CHILDREN, buildPaginatedUrl } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(APPOINTMENTS.BASE);

// Export service with additional custom methods
export const AppointmentService = {
  ...baseCRUD,

  // Dropdown data
  getDropdowns: () => fetchDropdowns(DROPDOWNS.BASE),
  getCenters: () => fetchDropdowns(DROPDOWNS.VACCINATION_CENTERS),
  getMedicalStaff: () => fetchDropdowns(DROPDOWNS.MEDICAL_STAFF),

  // Get time slots for a center
  getCenterSlots: async (clinicId) => {
    if (!clinicId) return null;
    const response = await api.get(`${APPOINTMENTS.BASE}/time-slots?clinicId=${clinicId}`);
    return response.data;
  },

  // Get parents list
  getParents: async ({ page = 1, limit = 5, status = 'ACTIVE' } = {}) => {
    const response = await api.get(buildPaginatedUrl(PARENTS.ALL, page, limit, { status }));
    return response.data;
  },

  // Get children by parent
  getChildrenByParent: async (parentId) => {
    const query = parentId ? CHILDREN.BY_PARENT(parentId) : CHILDREN.ALL;
    const response = await api.get(query);
    return response.data;
  },
};

export default AppointmentService;
